import React from 'react'
import Header from '../../Modules/Header/Header'
import NewsPage from './NewsPage'

const PagesNews = () => {
  return (
    <div>
      <Header />
      <NewsPage />
    </div>
  )
}

export default PagesNews
